export default __webpack_public_path__ + "static/media/Loader.b2703b17.svg";